import type {Configuration} from '../configuration';
import type {AxiosInstance, AxiosPromise, RawAxiosRequestConfig} from 'axios';
import {BASE_PATH, BaseAPI, operationServerMap, RequestArgs} from '../base';
import globalAxios from 'axios';
import {
  assertParamExists,
  createRequestFunction,
  DUMMY_BASE_URL,
  IdRsp,
  serializeDataIfNeeded,
  setSearchParams,
  toPathString,
} from '../common';
import {
  Apartment,
  ApartmentCreateReq,
  Apartments,
  ApartmentUpdateReq,
  ApartmentPermissionBulkGrantReq,
  ApartmentPermissionBulkRevokeReq,
  ApartmentPermissionBulkGrantRsp,
  ApartmentPermissionBulkUpdateRsp,
  ApartmentPermissionBulkRevokeRsp,
  ApartmentPermissionsRsp,
} from '../types/apartment';

/**
 * ApartmentServiceApi - axios parameter creator
 * @export
 */
export const ApartmentServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 公寓创建
     * @summary 公寓创建
     * @param {ApartmentCreateReq} apartmentCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apartmentServiceCreate: async (
      apartmentCreateReq: ApartmentCreateReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'apartmentCreateReq' is not null or undefined
      assertParamExists('apartmentServiceCreate', 'apartmentCreateReq', apartmentCreateReq);
      const localVarPath = `/apartment/apartment`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apartmentCreateReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 公寓删除
     * @summary 公寓删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apartmentServiceDelete: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('apartmentServiceDelete', 'id', id);
      const localVarPath = `/apartment/apartment/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 公寓详情
     * @summary 公寓详情
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apartmentServiceDetail: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('apartmentServiceDetail', 'id', id);
      const localVarPath = `/apartment/apartment/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 公寓查询
     * @summary 公寓查询
     * @param {string} [orgId]
     * @param {Array<string>} [ids]
     * @param {string} [name] search name
     * @param {string} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apartmentServiceFind: async (
      orgId?: string,
      ids?: Array<string>,
      name?: string,
      userId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/apartment/apartments`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (orgId !== undefined) {
        localVarQueryParameter['orgId'] = orgId;
      }

      if (ids) {
        localVarQueryParameter['ids'] = ids;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 公寓修改
     * @summary 公寓修改
     * @param {string} apartmentId
     * @param {ApartmentUpdateReq} apartmentUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apartmentServiceUpdate: async (
      apartmentId: string,
      apartmentUpdateReq: ApartmentUpdateReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'apartmentId' is not null or undefined
      assertParamExists('apartmentServiceUpdate', 'apartmentId', apartmentId);
      // verify required parameter 'apartmentUpdateReq' is not null or undefined
      assertParamExists('apartmentServiceUpdate', 'apartmentUpdateReq', apartmentUpdateReq);
      const localVarPath = `/apartment/apartment/{apartmentId}`.replace(
        `{${'apartmentId'}}`,
        encodeURIComponent(String(apartmentId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apartmentUpdateReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },

    /**
     * Bulk grant apartment permissions to user
     * @summary Bulk grant apartment permissions to user
     * @param {string} userId
     * @param {ApartmentPermissionBulkGrantReq} apartmentPermissionBulkGrantReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apartmentServiceBulkGrantPermissions: async (
      userId: string,
      apartmentPermissionBulkGrantReq: ApartmentPermissionBulkGrantReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apartmentServiceBulkGrantPermissions', 'userId', userId);
      // verify required parameter 'apartmentPermissionBulkGrantReq' is not null or undefined
      assertParamExists(
        'apartmentServiceBulkGrantPermissions',
        'apartmentPermissionBulkGrantReq',
        apartmentPermissionBulkGrantReq
      );
      const localVarPath = `/apartment/users/{userId}/apartment-permissions/bulk-grant`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apartmentPermissionBulkGrantReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },

    /**
     * Bulk update user's apartment permissions
     * @summary Bulk update user's apartment permissions
     * @param {string} userId
     * @param {ApartmentPermissionBulkGrantReq} apartmentPermissionBulkGrantReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apartmentServiceBulkUpdatePermissions: async (
      userId: string,
      apartmentPermissionBulkGrantReq: ApartmentPermissionBulkGrantReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apartmentServiceBulkUpdatePermissions', 'userId', userId);
      // verify required parameter 'apartmentPermissionBulkGrantReq' is not null or undefined
      assertParamExists(
        'apartmentServiceBulkUpdatePermissions',
        'apartmentPermissionBulkGrantReq',
        apartmentPermissionBulkGrantReq
      );
      const localVarPath = `/apartment/users/{userId}/apartment-permissions`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apartmentPermissionBulkGrantReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },

    /**
     * Bulk revoke apartment permissions from user
     * @summary Bulk revoke apartment permissions from user
     * @param {string} userId
     * @param {ApartmentPermissionBulkRevokeReq} apartmentPermissionBulkRevokeReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apartmentServiceBulkRevokePermissions: async (
      userId: string,
      apartmentPermissionBulkRevokeReq: ApartmentPermissionBulkRevokeReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apartmentServiceBulkRevokePermissions', 'userId', userId);
      // verify required parameter 'apartmentPermissionBulkRevokeReq' is not null or undefined
      assertParamExists(
        'apartmentServiceBulkRevokePermissions',
        'apartmentPermissionBulkRevokeReq',
        apartmentPermissionBulkRevokeReq
      );
      const localVarPath = `/apartment/users/{userId}/apartment-permissions/bulk-revoke`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apartmentPermissionBulkRevokeReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },

    /**
     * Get all users with permissions to an apartment
     * @summary Get all users with permissions to an apartment
     * @param {string} apartmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apartmentServiceGetPermissions: async (
      apartmentId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'apartmentId' is not null or undefined
      assertParamExists('apartmentServiceGetPermissions', 'apartmentId', apartmentId);
      const localVarPath = `/apartment/apartments/{apartmentId}/permissions`.replace(
        `{${'apartmentId'}}`,
        encodeURIComponent(String(apartmentId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ApartmentServiceApi - functional programming interface
 * @export
 */
export const ApartmentServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ApartmentServiceApiAxiosParamCreator(configuration);
  return {
    /**
     * 公寓创建
     * @summary 公寓创建
     * @param {ApartmentCreateReq} apartmentCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apartmentServiceCreate(
      apartmentCreateReq: ApartmentCreateReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdRsp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apartmentServiceCreate(
        apartmentCreateReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ApartmentServiceApi.apartmentServiceCreate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 公寓删除
     * @summary 公寓删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apartmentServiceDelete(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apartmentServiceDelete(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ApartmentServiceApi.apartmentServiceDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 公寓详情
     * @summary 公寓详情
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apartmentServiceDetail(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Apartment>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apartmentServiceDetail(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ApartmentServiceApi.apartmentServiceDetail']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 公寓查询
     * @summary 公寓查询
     * @param {string} [orgId]
     * @param {Array<string>} [ids]
     * @param {string} [name] search name
     * @param {string} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apartmentServiceFind(
      orgId?: string,
      ids?: Array<string>,
      name?: string,
      userId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Apartments>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apartmentServiceFind(
        orgId,
        ids,
        name,
        userId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ApartmentServiceApi.apartmentServiceFind']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 公寓修改
     * @summary 公寓修改
     * @param {string} apartmentId
     * @param {ApartmentUpdateReq} apartmentUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apartmentServiceUpdate(
      apartmentId: string,
      apartmentUpdateReq: ApartmentUpdateReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apartmentServiceUpdate(
        apartmentId,
        apartmentUpdateReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ApartmentServiceApi.apartmentServiceUpdate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },

    /**
     * Bulk grant apartment permissions to user
     * @summary Bulk grant apartment permissions to user
     * @param {string} userId
     * @param {ApartmentPermissionBulkGrantReq} apartmentPermissionBulkGrantReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apartmentServiceBulkGrantPermissions(
      userId: string,
      apartmentPermissionBulkGrantReq: ApartmentPermissionBulkGrantReq,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApartmentPermissionBulkGrantRsp>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apartmentServiceBulkGrantPermissions(
          userId,
          apartmentPermissionBulkGrantReq,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ApartmentServiceApi.apartmentServiceBulkGrantPermissions']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },

    /**
     * Bulk update user's apartment permissions
     * @summary Bulk update user's apartment permissions
     * @param {string} userId
     * @param {ApartmentPermissionBulkGrantReq} apartmentPermissionBulkGrantReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apartmentServiceBulkUpdatePermissions(
      userId: string,
      apartmentPermissionBulkGrantReq: ApartmentPermissionBulkGrantReq,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApartmentPermissionBulkUpdateRsp>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apartmentServiceBulkUpdatePermissions(
          userId,
          apartmentPermissionBulkGrantReq,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ApartmentServiceApi.apartmentServiceBulkUpdatePermissions']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },

    /**
     * Bulk revoke apartment permissions from user
     * @summary Bulk revoke apartment permissions from user
     * @param {string} userId
     * @param {ApartmentPermissionBulkRevokeReq} apartmentPermissionBulkRevokeReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apartmentServiceBulkRevokePermissions(
      userId: string,
      apartmentPermissionBulkRevokeReq: ApartmentPermissionBulkRevokeReq,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApartmentPermissionBulkRevokeRsp>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apartmentServiceBulkRevokePermissions(
          userId,
          apartmentPermissionBulkRevokeReq,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ApartmentServiceApi.apartmentServiceBulkRevokePermissions']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },

    /**
     * Get all users with permissions to an apartment
     * @summary Get all users with permissions to an apartment
     * @param {string} apartmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apartmentServiceGetPermissions(
      apartmentId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApartmentPermissionsRsp>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apartmentServiceGetPermissions(
        apartmentId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ApartmentServiceApi.apartmentServiceGetPermissions']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ApartmentServiceApi - factory interface
 * @export
 */
export const ApartmentServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ApartmentServiceApiFp(configuration);
  return {
    /**
     * 公寓创建
     * @summary 公寓创建
     * @param {ApartmentCreateReq} apartmentCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apartmentServiceCreate(
      apartmentCreateReq: ApartmentCreateReq,
      options?: any
    ): AxiosPromise<IdRsp> {
      return localVarFp
        .apartmentServiceCreate(apartmentCreateReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 公寓删除
     * @summary 公寓删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apartmentServiceDelete(id: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .apartmentServiceDelete(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 公寓详情
     * @summary 公寓详情
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apartmentServiceDetail(id: string, options?: any): AxiosPromise<Apartment> {
      return localVarFp
        .apartmentServiceDetail(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 公寓查询
     * @summary 公寓查询
     * @param {string} [orgId]
     * @param {Array<string>} [ids]
     * @param {string} [name] search name
     * @param {string} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apartmentServiceFind(
      orgId?: string,
      ids?: Array<string>,
      name?: string,
      userId?: string,
      options?: any
    ): AxiosPromise<Apartments> {
      return localVarFp
        .apartmentServiceFind(orgId, ids, name, userId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 公寓修改
     * @summary 公寓修改
     * @param {string} apartmentId
     * @param {ApartmentUpdateReq} apartmentUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apartmentServiceUpdate(
      apartmentId: string,
      apartmentUpdateReq: ApartmentUpdateReq,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .apartmentServiceUpdate(apartmentId, apartmentUpdateReq, options)
        .then(request => request(axios, basePath));
    },

    /**
     * Bulk grant apartment permissions to user
     * @summary Bulk grant apartment permissions to user
     * @param {string} userId
     * @param {ApartmentPermissionBulkGrantReq} apartmentPermissionBulkGrantReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apartmentServiceBulkGrantPermissions(
      userId: string,
      apartmentPermissionBulkGrantReq: ApartmentPermissionBulkGrantReq,
      options?: any
    ): AxiosPromise<ApartmentPermissionBulkGrantRsp> {
      return localVarFp
        .apartmentServiceBulkGrantPermissions(userId, apartmentPermissionBulkGrantReq, options)
        .then(request => request(axios, basePath));
    },

    /**
     * Bulk update user's apartment permissions
     * @summary Bulk update user's apartment permissions
     * @param {string} userId
     * @param {ApartmentPermissionBulkGrantReq} apartmentPermissionBulkGrantReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apartmentServiceBulkUpdatePermissions(
      userId: string,
      apartmentPermissionBulkGrantReq: ApartmentPermissionBulkGrantReq,
      options?: any
    ): AxiosPromise<ApartmentPermissionBulkUpdateRsp> {
      return localVarFp
        .apartmentServiceBulkUpdatePermissions(userId, apartmentPermissionBulkGrantReq, options)
        .then(request => request(axios, basePath));
    },

    /**
     * Bulk revoke apartment permissions from user
     * @summary Bulk revoke apartment permissions from user
     * @param {string} userId
     * @param {ApartmentPermissionBulkRevokeReq} apartmentPermissionBulkRevokeReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apartmentServiceBulkRevokePermissions(
      userId: string,
      apartmentPermissionBulkRevokeReq: ApartmentPermissionBulkRevokeReq,
      options?: any
    ): AxiosPromise<ApartmentPermissionBulkRevokeRsp> {
      return localVarFp
        .apartmentServiceBulkRevokePermissions(userId, apartmentPermissionBulkRevokeReq, options)
        .then(request => request(axios, basePath));
    },

    /**
     * Get all users with permissions to an apartment
     * @summary Get all users with permissions to an apartment
     * @param {string} apartmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apartmentServiceGetPermissions(
      apartmentId: string,
      options?: any
    ): AxiosPromise<ApartmentPermissionsRsp> {
      return localVarFp
        .apartmentServiceGetPermissions(apartmentId, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * ApartmentServiceApi - object-oriented interface
 * @export
 * @class ApartmentServiceApi
 * @extends {BaseAPI}
 */
export class ApartmentServiceApi extends BaseAPI {
  /**
   * 公寓创建
   * @summary 公寓创建
   * @param {ApartmentCreateReq} apartmentCreateReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApartmentServiceApi
   */
  public apartmentServiceCreate(
    apartmentCreateReq: ApartmentCreateReq,
    options?: RawAxiosRequestConfig
  ) {
    return ApartmentServiceApiFp(this.configuration)
      .apartmentServiceCreate(apartmentCreateReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 公寓删除
   * @summary 公寓删除
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApartmentServiceApi
   */
  public apartmentServiceDelete(id: string, options?: RawAxiosRequestConfig) {
    return ApartmentServiceApiFp(this.configuration)
      .apartmentServiceDelete(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 公寓详情
   * @summary 公寓详情
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApartmentServiceApi
   */
  public apartmentServiceDetail(id: string, options?: RawAxiosRequestConfig) {
    return ApartmentServiceApiFp(this.configuration)
      .apartmentServiceDetail(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 公寓查询
   * @summary 公寓查询
   * @param {string} [orgId]
   * @param {Array<string>} [ids]
   * @param {string} [name] search name
   * @param {string} [userId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApartmentServiceApi
   */
  public apartmentServiceFind(
    orgId?: string,
    ids?: Array<string>,
    name?: string,
    userId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApartmentServiceApiFp(this.configuration)
      .apartmentServiceFind(orgId, ids, name, userId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 公寓修改
   * @summary 公寓修改
   * @param {string} apartmentId
   * @param {ApartmentUpdateReq} apartmentUpdateReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApartmentServiceApi
   */
  public apartmentServiceUpdate(
    apartmentId: string,
    apartmentUpdateReq: ApartmentUpdateReq,
    options?: RawAxiosRequestConfig
  ) {
    return ApartmentServiceApiFp(this.configuration)
      .apartmentServiceUpdate(apartmentId, apartmentUpdateReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Bulk grant apartment permissions to user
   * @summary Bulk grant apartment permissions to user
   * @param {string} userId
   * @param {ApartmentPermissionBulkGrantReq} apartmentPermissionBulkGrantReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApartmentServiceApi
   */
  public apartmentServiceBulkGrantPermissions(
    userId: string,
    apartmentPermissionBulkGrantReq: ApartmentPermissionBulkGrantReq,
    options?: RawAxiosRequestConfig
  ) {
    return ApartmentServiceApiFp(this.configuration)
      .apartmentServiceBulkGrantPermissions(userId, apartmentPermissionBulkGrantReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Bulk update user's apartment permissions
   * @summary Bulk update user's apartment permissions
   * @param {string} userId
   * @param {ApartmentPermissionBulkGrantReq} apartmentPermissionBulkGrantReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApartmentServiceApi
   */
  public apartmentServiceBulkUpdatePermissions(
    userId: string,
    apartmentPermissionBulkGrantReq: ApartmentPermissionBulkGrantReq,
    options?: RawAxiosRequestConfig
  ) {
    return ApartmentServiceApiFp(this.configuration)
      .apartmentServiceBulkUpdatePermissions(userId, apartmentPermissionBulkGrantReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Bulk revoke apartment permissions from user
   * @summary Bulk revoke apartment permissions from user
   * @param {string} userId
   * @param {ApartmentPermissionBulkRevokeReq} apartmentPermissionBulkRevokeReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApartmentServiceApi
   */
  public apartmentServiceBulkRevokePermissions(
    userId: string,
    apartmentPermissionBulkRevokeReq: ApartmentPermissionBulkRevokeReq,
    options?: RawAxiosRequestConfig
  ) {
    return ApartmentServiceApiFp(this.configuration)
      .apartmentServiceBulkRevokePermissions(userId, apartmentPermissionBulkRevokeReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Get all users with permissions to an apartment
   * @summary Get all users with permissions to an apartment
   * @param {string} apartmentId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApartmentServiceApi
   */
  public apartmentServiceGetPermissions(apartmentId: string, options?: RawAxiosRequestConfig) {
    return ApartmentServiceApiFp(this.configuration)
      .apartmentServiceGetPermissions(apartmentId, options)
      .then(request => request(this.axios, this.basePath));
  }
}
